import { energyApi } from "utilities/Axios";

export const signOut = () => {
    // return authApi.get("/api/auth/sign-out",);
};

export const callbacklogin = () => {
    // return authApi.get("api/auth/external-auth-callback",);
};

export const getAvatar = () => {
    // return authApi.get("/user/getavatar",);
};


export const uploadPicture = (module: number, data: any) => {
    // return commonApi.post("/Api/File/Upload?module="+module, data, {
    //   headers: {
    //     "Content-Type": "multipart/form-data",
    //   } 
    // });
};
export const mapPicture = (data: any) => {
    // return authApi.post("/api/user/mappicture", data);
};

export const updateProfile = (data: any) => {
    // return authApi.post("/api/user/edituser", data,);
};

export const resetPassword = (data: any) => {
    return energyApi.post("/api/Auth/reset-password", data);
};
